import { showDuplicateJournalNumbers } from './duplicate-journal-numbers.js'
import { showMissingJournals } from './missing-journals.js'
import { showJournalsWithNoLines } from './with-no-lines.js'

export async function showJournalsIssues (accountingOrganisationId) {
  console.log('showJournalsIssues show()', accountingOrganisationId)

  await showJournalsWithNoLines(accountingOrganisationId)
  await showMissingJournals(accountingOrganisationId)
  await showDuplicateJournalNumbers(accountingOrganisationId)
}
